
import UserFormFields from './FormFields'

const ProgramUserFormFields = (props) => {
    return (
        <div className="program-user-form-fields w100">
            <UserFormFields {...props} />
        </div>
    )
}

export default ProgramUserFormFields